import React from 'react'

export default function Error({ error }) {
  let finalMessage = ''

  if (!error) {
    return null
  }

  if (error?.response?.data?.errors) {
    error.response.data.errors.forEach(err => {
      finalMessage += `${err.message}\n`
    })
  }

  let { message } = error

  if (error.response?.status === 401 || message.indexOf('Access') === 0) {
    finalMessage = finalMessage || 'Sign in failed. Please try again or try resetting your password.'
  }

  return <div className="invalid-feedback field-container">{finalMessage}</div>
}
